import { Fragment as e, TransitionGroup as t, computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createSlots as s, createTextVNode as c, createVNode as l, defineComponent as u, normalizeClass as d, normalizeStyle as f, openBlock as p, readonly as m, ref as h, renderList as g, renderSlot as _, toDisplayString as v, unref as y, withCtx as b } from "vue";
import { CheckRounded as x, Error as S, IconBase as C, IconSize as w, Info as T, Times as E } from "@myparcel-frontend/ui";
import { useI18n as D } from "vue-i18n";
//#region src/types/notification.types.ts
var O = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, k = {
	Full: "full",
	Half: "half"
}, A = { Toaster: "toaster" }, j = { key: 0 }, M = { class: "content flex flex-col grow" }, N = { class: "empty:hidden font-bold" }, P = { class: "body" }, F = /* @__PURE__ */ u({
	__name: "Toast",
	props: {
		id: { default: "" },
		variant: {},
		timeout: { default: 6e3 },
		size: { default: k.Full },
		canClose: { type: Boolean },
		withShadow: { type: Boolean }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let s = e, c = t;
		s.timeout && s.id && setTimeout(() => {
			c("remove", s.id);
		}, s.timeout);
		let u = n(() => s.variant === O.Info), m = n(() => s.variant === O.Error), h = n(() => s.variant === O.Warning), g = n(() => s.variant === O.Success);
		return (t, n) => (p(), a("div", {
			"aria-atomic": "true",
			"aria-live": "polite",
			class: d(["border border-gray-400 flex items-center mb-4 md:text-base overflow-hidden p-4 pointer-events-auto relative rounded-lg transform-gpu", {
				"drop-shadow-md": e.withShadow,
				"pb-5!": !!e.timeout,
				"md:min-w-[400px] md:max-w-3xl md:min-h-[56px]": e.size === y(k).Half,
				"bg-green-100": g.value,
				"bg-blue-100": u.value,
				"bg-yellow-100": h.value,
				"bg-red-100": m.value
			}]),
			"data-test": "toast",
			role: "status"
		}, [
			e.timeout ? (p(), a("div", j, [o("div", {
				class: d(["absolute bottom-0 h-1 left-0 origin-left w-full animate-shrink", {
					"bg-blue": u.value,
					"bg-green": g.value,
					"bg-yellow": h.value,
					"bg-red": m.value
				}]),
				style: f({ "animation-duration": e.timeout + "ms" })
			}, null, 6), o("div", { class: d(["absolute bottom-0 h-1 left-0 opacity-20 w-full", {
				"bg-blue": u.value,
				"bg-green": g.value,
				"bg-yellow": h.value,
				"bg-red": m.value
			}]) }, null, 2)])) : (p(), a("div", {
				key: 1,
				class: d(["absolute h-full left-0 top-0 w-1", {
					"bg-blue": u.value,
					"bg-green": g.value,
					"bg-yellow": h.value,
					"bg-red": m.value
				}])
			}, null, 2)),
			o("div", { class: d(["flex-none pr-4", {
				"text-blue": u.value,
				"text-green": g.value,
				"text-yellow": h.value,
				"text-red": m.value
			}]) }, [l(y(C), { size: y(w).Normal }, {
				default: b(() => [
					u.value ? (p(), r(y(T), { key: 0 })) : i("", !0),
					m.value ? (p(), r(y(S), { key: 1 })) : i("", !0),
					h.value ? (p(), r(y(S), { key: 2 })) : i("", !0),
					g.value ? (p(), r(y(x), { key: 3 })) : i("", !0)
				]),
				_: 1
			}, 8, ["size"])], 2),
			o("div", M, [o("div", N, [_(t.$slots, "title")]), o("div", P, [_(t.$slots, "default")])]),
			e.canClose ? (p(), a("button", {
				key: 2,
				class: "button close flex-none pl-4",
				type: "button",
				onClick: n[0] ||= (n) => t.$emit("remove", e.id)
			}, [l(y(C), {
				class: "cursor-pointer",
				size: y(w).Normal
			}, {
				default: b(() => [l(y(E))]),
				_: 1
			}, 8, ["size"])])) : i("", !0)
		], 2));
	}
}), I = h([]), L = h(0), R = 6e3, z = 3e4;
function B() {
	let e = ({ id: e, variant: n = O.Info, canClose: r, withShadow: i, body: a, title: o, timeout: s = R, location: c = A.Toaster }) => {
		let l = e;
		l ||= (L.value++, L.value.toString());
		let u = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : Math.min(s, z);
		I.value.some((e) => e.id === l) || I.value.unshift({
			id: l,
			body: a,
			variant: n,
			title: o,
			timeout: u,
			location: c,
			canClose: u ? r : !0,
			withShadow: i
		}), u && setTimeout(() => {
			t(l);
		}, u);
	}, t = (e) => {
		I.value = I.value.filter((t) => t.id !== e);
	};
	return {
		notifications: m(I),
		addNotification: e,
		removeNotification: t,
		clearNotifications: () => {
			I.value = [];
		}
	};
}
//#endregion
//#region src/components/LocationContainer/LocationContainer.vue?vue&type=script&setup=true&lang.ts
var V = ["data-test"], H = /* @__PURE__ */ u({
	__name: "LocationContainer",
	props: { location: {} },
	setup(t) {
		let { notifications: i, removeNotification: o } = B(), l = t, u = n(() => i.value.filter((e) => e.location === l.location));
		return (n, i) => (p(), a("div", { "data-test": `notifications ${t.location}` }, [(p(!0), a(e, null, g(u.value, (e) => (p(), r(F, {
			id: e.id,
			key: e.id,
			"can-close": e.canClose,
			class: "flex-none",
			size: y(k).Full,
			timeout: e.timeout,
			variant: e.variant,
			"with-shadow": e.withShadow,
			onRemove: y(o)
		}, s({
			default: b(() => [c(" " + v(e.body), 1)]),
			_: 2
		}, [e.title ? {
			name: "title",
			fn: b(() => [c(v(e.title), 1)]),
			key: "0"
		} : void 0]), 1032, [
			"id",
			"can-close",
			"size",
			"timeout",
			"variant",
			"with-shadow",
			"onRemove"
		]))), 128))], 8, V));
	}
}), U = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, W = /* @__PURE__ */ U(H, [["__scopeId", "data-v-4e672e0e"]]), G = /* @__PURE__ */ u({
	__name: "Notification",
	props: {
		id: {},
		variant: {},
		canClose: { type: Boolean },
		withShadow: { type: Boolean },
		timeout: { default: 0 }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let n = t, a = h(!0), o = () => {
			a.value = !1, n("remove");
		};
		return (t, n) => a.value ? (p(), r(F, {
			key: 0,
			id: e.id,
			"can-close": e.canClose,
			class: "relative",
			"data-test": "notification",
			timeout: e.timeout,
			variant: e.variant,
			"with-shadow": e.withShadow,
			onRemove: o
		}, {
			title: b(() => [_(t.$slots, "title")]),
			default: b(() => [_(t.$slots, "default")]),
			_: 3
		}, 8, [
			"id",
			"can-close",
			"timeout",
			"variant",
			"with-shadow"
		])) : i("", !0);
	}
}), K = { id: "notification__container" }, q = /* @__PURE__ */ U(/* @__PURE__ */ u({
	__name: "NotificationContainer",
	setup(i) {
		let { t: o, te: u } = D(), { notifications: d, removeNotification: f } = B(), m = n(() => d.value.filter((e) => e.location === A.Toaster)), h = (e) => u(e) ? o(e) : e;
		return (n, i) => (p(), a("div", K, [l(t, { name: "list" }, {
			default: b(() => [(p(!0), a(e, null, g(m.value, (e) => (p(), r(F, {
				id: e.id,
				key: e.id,
				"can-close": e.canClose,
				class: "flex-none",
				size: y(k).Half,
				timeout: e.timeout,
				variant: e.variant,
				"with-shadow": e.withShadow,
				onRemove: y(f)
			}, s({
				default: b(() => [c(" " + v(h(e.body)), 1)]),
				_: 2
			}, [e.title ? {
				name: "title",
				fn: b(() => [c(v(h(e.title)), 1)]),
				key: "0"
			} : void 0]), 1032, [
				"id",
				"can-close",
				"size",
				"timeout",
				"variant",
				"with-shadow",
				"onRemove"
			]))), 128))]),
			_: 1
		})]));
	}
}), [["__scopeId", "data-v-179bca82"]]);
//#endregion
export { W as LocationContainer, G as Notification, q as NotificationContainer, A as NotificationLocation, k as NotificationSize, O as NotificationVariant, B as useNotification };
